var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "pxf-content" } },
    [
      _c("h4", [_vm._v(_vm._s(_vm.headerBlockDto.title))]),
      _vm._v(" "),
      _c("p", [_c("strong", [_vm._v(_vm._s(_vm.headerBlockDto.subTitle))])]),
      _vm._v(" "),
      _c("p", { staticClass: "lead mb-0" }, [
        _c("strong", [_vm._v(_vm._s(_vm.tableTitle))]),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "lead",
        attrs: { id: "table-description" },
        domProps: { innerHTML: _vm._s(_vm.tableSubTitle) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-container" }, [
        _c(
          "table",
          {
            staticClass: "table text-gray3",
            attrs: { "aria-labelledby": "table-description" },
          },
          [
            _c("thead", { staticClass: "text-dark lead" }, [
              _c(
                "tr",
                [
                  _c("th", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        Les modalités\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.durations, function (duration) {
                    return _c(
                      "th",
                      { key: duration, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(duration) +
                            "x\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c(
                "tr",
                [
                  _c("td", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        Mensualité\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.monthlyAmounts, function (amount, i) {
                    return _c(
                      "td",
                      { key: "amount" + i, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(amount) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "tr",
                [
                  _c("td", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        Montant total dû\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.totalAmounts, function (total, i) {
                    return _c(
                      "td",
                      { key: "total" + i, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(total) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "tr",
                [
                  _c("td", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        TAEG fixe\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.taegRates, function (taeg, i) {
                    return _c(
                      "td",
                      { key: "taeg" + i, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(taeg) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "tr",
                [
                  _c("td", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        Taux débiteur fixe\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.nominalRates, function (nominal, i) {
                    return _c(
                      "td",
                      { key: "nominal" + i, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(nominal) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "tr",
                [
                  _c("td", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        Coût du crédit\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.creditCosts, function (cost, i) {
                    return _c(
                      "td",
                      { key: "cost" + i, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(cost) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "tr",
                [
                  _c("td", { staticClass: "px-1 pb-1" }, [
                    _vm._v(
                      "\n                        Montant du financement\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.fundingAmounts, function (funding, i) {
                    return _c(
                      "td",
                      { key: "funding-" + i, staticClass: "px-1 pb-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(funding) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "small" }, [
        _c("strong", [_vm._v(_vm._s(_vm.pxfLegalMentionsText))]),
      ]),
      _vm._v(" "),
      _c(
        "ob1-liens-haut-bas",
        {
          attrs: {
            "is-collapsed": false,
            "is-large": true,
            "collapsed-block-id": "financing-pxf-block",
            "button-label": _vm.financingBlock.title,
            "button-id": "financing-pxf-link",
          },
        },
        [_c("p", { domProps: { innerHTML: _vm._s(_vm.financingBlock.text) } })]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row pt-2 pb-1" },
        [
          _c("ob1-picture", {
            staticClass: "illustration mx-auto",
            attrs: { visual: _vm.illustration },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-gray2 px-2 pb-1 mb-1 mb-md-2" },
        [
          _c("p", { staticClass: "mb-0" }, [
            _c("strong", [_vm._v(_vm._s(_vm.howToBenefitDto.title))]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.howToBenefitDto.subTitle))]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.howToBenefitDto.texts, function (howToBenefitText, index) {
            return _c(
              "p",
              {
                key: "how-to-" + index,
                staticClass: "d-flex align-items-start mb-0",
              },
              [
                _c("span", {
                  staticClass: "font-size-24",
                  class: "icon-number-" + _vm.getIndex(index) + "-wired",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "ml-1 how-to-benefit",
                  domProps: { innerHTML: _vm._s(howToBenefitText) },
                }),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center mt-2 mb-4" },
        [
          _c("ob1-boutons", {
            attrs: {
              label: _vm.howToBenefitDto.link.label,
              href: _vm.howToBenefitDto.link.url,
              target: "_blank",
              "is-button": false,
              "is-secondary": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ob1-liens-haut-bas",
        {
          attrs: {
            "is-collapsed": false,
            "collapsed-block-id": "legal-mentions-pxf-block",
            "button-label": _vm.cgu.title,
            "button-id": "legal-mentions-pxf-link",
          },
        },
        [
          _c("p", {
            staticClass: "small",
            domProps: { innerHTML: _vm._s(_vm.cgu.text) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }